/**
 * 消息中心
 **/

import React from 'react';
import { Col, message, Modal, Row, Table, Select ,Alert} from "antd";
import { findCusWjwReport, findCusWjwTotalReport } from "../../services/customization";
import { connect } from "react-redux";
import { removeBlankValParamsStringParam } from "../../utils";
import { findEventSomples } from "../../services/evt";


class CreditSystemStatus extends React.Component {

    constructor(props) {
        super(props);
        this.defaultTablePagination = {
            pageSizeOptions: ['1', '20', '50', '100'],
            defaultPageSize: 20,
            showSizeChanger: true,
            showTotal: total => `共 ${total} 条`,
        }
        this.informationColumns = [{
            title: '活动名称',
            dataIndex: '',
            key: 'id',
            width: 300,
            render: (text, record, index) => (
                <div>
                    <div style={{ fontSize: 12, color: '#9e9e9e', }}>{record.eventName}</div>
                </div>
            ),
        },
        {
            title: '总参与人',
            dataIndex: 'totalCount',
            width: 160,
        },
        {
            title: '合格参与人',
            dataIndex: 'completionCount',
            width: 160,
        },
        {
            title: '合格率',
            dataIndex: 'completionRate',
            render: (text, record, index) => (
                <div>
                    {text}%
                </div>
            ),

        },
        ];
        this.state = {
            events: [],
            selectEvents: [],
            totalData: null,
            eventId: null,
            type: null,
            broadcastVisible: false,
            broadcastItem: null,
            informationResponse: {
                isFetching: true,
                data: [],
                pagination: {
                    total: 0,
                    defaultPageSize: 20,
                    current: 1,
                },
            },
            informationSearchParams: {
                eventIds: ''
            },

        }
    }

    componentWillReceiveProps(nextProps) {


    }

    componentDidMount() {
        this.fetchCashAccountTrans()
        findEventSomples().then(res => {
            if (res.code == 200) {
                this.setState({ events: res.data })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
        findCusWjwTotalReport().then(res => {
            if (res.code == 200) {
                this.setState({ totalData: res.data })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }



    fetchCashAccountTrans(pagination, sort) {
        const params = Object.assign(removeBlankValParamsStringParam(this.state.informationSearchParams), { page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20 })
        this.setState({
            informationResponse: Object.assign(this.state.informationResponse, { isFetching: true })
        })
        findCusWjwReport(params).then(res => {
            if (res.code == 200) {
                const { data, ...page } = res
                this.setState({
                    informationResponse: {
                        taskVisible: false,
                        isFetching: false,
                        data: data,
                        pagination: {
                            total: page.total,
                            defaultPageSize: page.pageSize,
                            current: page.page,
                        },
                    },
                })
            } else {
                message.error(res.msg,6);
            }
        }).catch(err => {
            message.warn("访问异常");
        })
    }

    informationTableChange = (pagination, filters, sorter) => {
        this.fetchCashAccountTrans(pagination, sorter);
    }
    informationSearchParamsChange(propName, val, invokingFetchFilterTableData = true) {
        const searchParams = { ...this.state.informationSearchParams };
        searchParams[propName] = val;
        this.setState({
            informationSearchParams: searchParams,
        }, () => {
            if (invokingFetchFilterTableData) {
                this.fetchCashAccountTrans();
            }
        });
    }
    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }
    hideModal = () => {
        this.setState({
            taskVisible: false,
        });
    }


    render() {
        const { totalData } = this.state;
        const content = <Row>
            <Col  span={12}>
                <Alert message={<div>
                    <span>活动总数：{totalData ? totalData.totalEventCount : 0}</span>
                    <span style={{ marginLeft: 10 }}>参与人总数：{totalData ? totalData.totalCount : 0}</span>
                    <span style={{ marginLeft: 10 }}>合格总数：{totalData ? totalData.completionCount : 0}</span>
                    <span style={{ marginLeft: 10 }}>合格率：{totalData ? `${totalData.completionRate}%` : 0}</span>
                </div>} type="info" />
            </Col>
            <Col span={24} style={{ marginBottom: 16 }}>
                <Select
                    mode="multiple"
                    size="large"
                    style={{ width: "100%" }}
                    value={this.state.selectEvents}
                    placeholder="请选择活动"
                    onChange={(val) => {
                        this.setState({ selectEvents: val });
                        this.informationSearchParamsChange("eventIds", val.join(','))
                    }}
                >
                    {
                        this.state.events.map((obj, index) => (
                            <Select.Option key={index} value={obj.id}>{obj.name}</Select.Option>
                        ))
                    }
                </Select>
            </Col>
            <Col span={24}>
                <Table
                    columns={this.informationColumns}
                    showHeader={true}
                    loading={this.state.informationResponse.isFetching}
                    dataSource={this.state.informationResponse.data}
                    pagination={false}
                    onChange={this.informationTableChange}
                    scroll={{ x: 546, y: 'calc(100vh - 518px)' }}
                />
            </Col>
        </Row>
        return (
            <div>
                {content}
            </div>

        )
    }
}

const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    return { cmEnums };
};
const mapDispatchToProps = dispatch => ({});


export default connect(mapStateToPorps, mapDispatchToProps)(CreditSystemStatus);



// WEBPACK FOOTER //
// ./src/containers/usersfrom/CreditSystemStatus.jsx